import React from 'react';
import { Percent, MonitorSmartphone, MessageCircle, ShieldCheck, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function ValuePropsSection() {
  const {
    t
  } = useLanguage();
  const valueProps = [{
    icon: Percent,
    title: t('valueProps.1.title'),
    description: t('valueProps.1.desc')
  }, {
    icon: MonitorSmartphone,
    title: t('valueProps.2.title'),
    description: t('valueProps.2.desc')
  }, {
    icon: MessageCircle,
    title: t('valueProps.3.title'),
    description: t('valueProps.3.desc')
  }, {
    icon: ShieldCheck,
    title: t('valueProps.4.title'),
    description: t('valueProps.4.desc')
  }, {
    icon: MapPin,
    title: t('valueProps.5.title'),
    description: t('valueProps.5.desc')
  }];
  return <section id="servicios" className="bg-lightGray py-16 md:py-24" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-132">
          {valueProps.map((prop, index) => {
          const Icon = prop.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow" data-id="element-133">
                <div className="w-12 h-12 bg-gold bg-opacity-10 rounded-lg flex items-center justify-center mb-4" data-id="element-134">
                  <Icon className="text-gold" size={24} data-id="element-135" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-navy" data-id="element-136">
                  {prop.title}
                </h3>
                <p className="text-gray-600" data-id="element-137">{prop.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}